<template>
    <div>
        <v-overlay :value="loading" absolute>
            <v-progress-circular indeterminate size="64" color="primary" />
        </v-overlay>
        <div v-if="!loading">
            <app-form
                ref="form"
                v-bind:parentObject="{
                    data: this.formData,
                    searchnew: this.search,
                    pageTitle: this.pageTitle,
                    pageTitleValue: this.pageTitleValue,
                    errMsg: this.errMsg,
                    isEdit: this.editMode,
                }"
                v-on:new="createHandler"
                v-on:input="formData = $event"
                v-on:save="saveHandler"
                v-on:cancel="cancelHandler"
                v-on:delete="isConfirm = !isConfirm"
            />
            <div v-if="isErr">
                <app-error
                    v-bind:parentError="{
                        data: this.errMsg,
                        isErr: this.isErr,
                    }"
                    v-on:closeError="isErr = $event"
                />
            </div>
            <div v-if="isConfirm">
                <app-confirm
                    v-bind:parentObject="{
                        pageTitleValue: this.pageTitleValue,
                        isConfirm: this.isConfirm,
                    }"
                    v-on:confirm="deleteHandler($event)"
                    v-on:cancelConfirm="isConfirm = !isConfirm"
                />
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import AttendanceIncentiveSetupForm from '../../../components/attendance/attendanceincentivesetup/Form';
import ErrorDialog from '../../../components/common/ErrorDialog';
import ConfirmDialog from '../../../components/common/ConfirmDialog';

export default {
    components: {
        'app-form': AttendanceIncentiveSetupForm,
        'app-error': ErrorDialog,
        'app-confirm': ConfirmDialog,
    },

    data() {
        return {
            id: this.$route.params.id,
            search: this.$route.params.search,
            pageTitle: this.$t('attendanceincentivesetup.editattendanceincentivesetup'),
            pageTitleValue: '',
            formData: {},
            loading: true,
            errMsg: '',
            isErr: false,
            isConfirm: false,
            editMode: true,
        };
    },

    methods: {
        loadAttendanceIncentiveSetupHandler() {
            const vm = this;
            return this.$store.dispatch('get', { url: '/attendanceincentivesetup/' + this.id })
                .then(res => {
                    vm.formData = res.data.rec[0];

                    if (res.data.rec[0].startdate) {
                        vm.formData.startdate = moment(res.data.rec[0].startdate).format('YYYY-MM-DD');
                    }
                    if (res.data.rec[0].enddate) {
                        vm.formData.enddate = moment(res.data.rec[0].enddate).format('YYYY-MM-DD');
                    }

                    vm.formData.userid = this.$store.getters.userId;
                    vm.pageTitleValue = res.data.rec[0].payitemdesc;
                })
                .catch(err => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                });
        },

        loadAttendanceIncentiveSetupDetailHandler() {
            const vm = this;
            return this.$store.dispatch('get', { url: '/attendanceincentivesetupd/' + this.id })
                .then(res => {
                    vm.formData.incentivedetail = res.data.rec || [];
                    for (let i = 0; i < vm.formData.incentivedetail.length; i++) {
                        const cond = vm.formData.incentivedetail[i];
                        Object.assign(cond, { action: 2 });
                        if (!Array.isArray(cond.daytypeids)) {
                            cond.daytypeids = cond.daytypeids ? String(cond.daytypeids).split(',').map(Number) : [];
                        }
                        if (!Array.isArray(cond.shiftids)) {
                            cond.shiftids = cond.shiftids ? String(cond.shiftids).split(',').map(Number) : [];
                        }
                        if (cond.mustfulfillshifthours === 'Y') {
                            cond.mustfulfillshifthours = true;
                        } else if (cond.mustfulfillshifthours === 'N') {
                            cond.mustfulfillshifthours = false;
                        }
                        cond.eligiblegroupdetail = [];
                    }
                })
                .catch(err => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                });
        },

        saveHandler() {
            const vm = this;

            if (!this.CheckPermission(this.$route.meta.funcname, 'canedit')) {
                return false;
            }

            this.$store.dispatch('put', { url: '/attendanceincentivesetup/' + vm.id, payload: vm.formData })
                .then(res => {
                    if (res.data.error) {
                        vm.handleSaveError(res.data.error);
                    } else {
                        this.$router.push({ name: 'attndincsetuplist', params: { search: this.search } });
                    }
                })
                .catch(err => {
                    vm.handleSaveError(err);
                });
        },

        handleSaveError(err) {
            const status = err && err.response ? err.response.status : null;
            const data = err && err.response ? err.response.data : null;
            const errorText = (data && (data.error || data.message)) || (typeof err === 'string' ? err : '');
            const isDuplicate = status === 409 || /description already exists/i.test(String(errorText));
            if (isDuplicate) {
                if (this.$refs.form && this.$refs.form.setDescriptionError) {
                    this.$refs.form.setDescriptionError(this.$t('attendanceincentivesetup.descriptionexists'));
                }
                return;
            }
            this.isErr = !this.isErr;
            this.errMsg = errorText || err;
        },

        cancelHandler() {
            this.$router.push({ name: 'attndincsetuplist' });
        },

        deleteHandler() {
            const vm = this;

            if (!this.CheckPermission(this.$route.meta.funcname, 'candelete')) {
                return false;
            }

            this.$store.dispatch('delete', { url: '/attendanceincentivesetup/' + vm.id + '/' + this.formData.userid })
                .then(res => {
                    if (res.data.error) {
                        vm.isErr = !vm.isErr;
                        vm.errMsg = res.data.error;
                    } else {
                        this.$router.push({ name: 'attndincsetuplist' });
                    }
                })
                .catch(err => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                });
        },

        createHandler() {
            this.$router.push({ name: 'attndincsetupnew' });
        },
    },

    async mounted() {
        try {
            await this.loadAttendanceIncentiveSetupHandler();
            await this.loadAttendanceIncentiveSetupDetailHandler();
        } finally {
            this.loading = false;
        }
    },
};
</script>
